import { render, staticRenderFns } from "./IndexGroup.vue?vue&type=template&id=a363df1c&"
import script from "./IndexGroup.vue?vue&type=script&lang=js&"
export * from "./IndexGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports